<template>
  <el-dialog
    title="批量处理"
    :visible.sync="visible"
    width="400px"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :append-to-body="true"
    :show-close="false"
    class="dialog"
  >
    <div class="loading-inbox">
      <a-spin size="large" class="loading-icon" />
      <div class="content">{{ content }}</div>
      <div class="tip">请勿关闭或刷新当前页面</div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  model: {
    prop: 'visible',
    event: 'change'
  },

  props: {
    content: {
      type: String,
      default: '正在批量处理, 请稍后...'
    },

    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog {
  z-index: 10000 !important;
  ::v-deep {
    .el-dialog {
      display: flex;
      flex-direction: column;
      margin: 0 !important;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .el-dialog .el-dialog__body {
      flex: 1;
      overflow: auto;
    }
  }
}
.loading-inbox {
  text-align: center;
  padding: 20px 0 40px;
  .loading-icon {
    padding-bottom: 14px;
  }
}
.tip {
  font-size: 14px;
  color: $second-text-color;
}
.content {
  font-size: 20px;
  color: $text-color;
  @include text-bold;
  padding-bottom: 8px;
}
</style>
